import {setDisplayTime} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {findDisplayTimeFromAvailableTimes} from '../utils/time_utils';

const _findAndSetDisplayTime = (store, selected_time) => {
  const dispatch = store.dispatch;
  const state = store.getState();
  const { indicators, time } = state;

  const active_layer = indicators.active;

  if (!active_layer) {
    return;
  }

  const available_times = active_layer.available_times;
  selected_time = selected_time || time.selected_time;
  const new_display_time = findDisplayTimeFromAvailableTimes(selected_time, available_times);

  dispatch(setDisplayTime(new_display_time));
};

export const orchestrateTime = store => next => action => {

  // First complete the current action
  const result = next(action);

  const state = store.getState();
  const { indicators } = state;

  switch (action.type) {

    // When the Indicator Times get updated for the active Indicator, reset the Display Time.
    case ActionTypes.UPDATE_INDICATOR_TIMES:
      if (indicators.active && indicators.active.prefix === action.indicator_prefix) {
        _findAndSetDisplayTime(store);
      }
      break;

    case ActionTypes.SET_DISPLAY_TIME_FOR_ACTIVE_INDICATOR:
      _findAndSetDisplayTime(store, action.selected_time);
      break;

    case ActionTypes.SET_DISPLAY_TIME:
      setTimeout(() => {
        const element = document.getElementById('selected-time');
        if (element) {
          element.scrollIntoView();
        }
      }, 300);
      break;

    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/timeMiddleware.js